import {Component, ElementRef, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import * as $ from 'jquery';
import {MapService} from '../../services/map.service';
import {LevelData} from '../../../interfaces/cards.interface';
import {MAX_LEVEL, MUSIC, TIME_WAIT_RENDER, MAX_LEVEL_UNLOCK} from '../../helper/constant';
import {Platform} from '@ionic/angular';
import {TranslateService} from '@ngx-translate/core';
import {NotificationService} from '../../services/notification.service';
import {Account} from '../../../Api/models';
import {takeUntil} from 'rxjs/operators';
import {Subject} from 'rxjs';

let scroll;
let mapsProperties;
// declare const playSound: any;
// let soundMute = false;

@Component({
    selector: 'app-game-level',
    templateUrl: './game-level.component.html',
    styleUrls: ['./game-level.component.scss'],
})
export class GameLevelComponent implements OnInit, OnDestroy {
    @Input() musicSrc = '';
    @Input() data: LevelData;
    @Input() gameActive = 'lock';
    @ViewChild('container', {static: true}) container: ElementRef;
    gameInit = true;
    MAX_LEVEL = MAX_LEVEL;
    MAX_LEVEL_UNLOCK = MAX_LEVEL_UNLOCK;
    componentDestroyed$: Subject<boolean> = new Subject();

    constructor(public router: Router,
                private mapService: MapService,
                private activatedRoute: ActivatedRoute,
                private platform: Platform,
                private translate: TranslateService,
                private noticationService: NotificationService) {
    }

    ngOnDestroy() {
        console.log('Clear Subscription!');
        this.componentDestroyed$.next(true);
        this.componentDestroyed$.complete();
    }

    ngOnInit() {
        mapsProperties = this.mapService.getMapsProperties();
        this.gameActive = this.mapService.getActiveGame();
        // soundMute = this.mapService.getSoundConfig();
        setTimeout(() => {
            this.dragAble();
            this.activatedRoute.queryParams
                .pipe(takeUntil(this.componentDestroyed$))
                .subscribe((queryParams) => {
                    if (this.data.maps && this.data.maps.length > 0) {
                        if (this.data.currentLevel > 1) {
                            scroll = 'level' + (this.data.currentLevel);
                        } else {
                            scroll = 'level1';
                        }
                        const elmnt = document.getElementById(scroll);
                        if (elmnt) {
                            elmnt.scrollIntoView();
                        }


                    }
                    if (!this.mapService.getMusic()) {
                        this.mapService.playMusic(MUSIC.main);
                    } else {
                        if (this.mapService.getSoundIsPlay() !== MUSIC.main) {
                            this.mapService.playMusic(MUSIC.main);
                        }
                    }
                    setTimeout(() => {
                        this.gameInit = false;
                    }, TIME_WAIT_RENDER);
                }, error1 => {
                    setTimeout(() => {
                        this.gameInit = false;
                    }, TIME_WAIT_RENDER);
                    console.log('queryParams', error1);
                });
            // console.log('GameDataInternal:', this.data);
        }, 50);
    }

    dragAble() {
        const slider = document.querySelector('.scroll');
        let isDown = false;
        let startX;
        let scrollLeft;
        slider.addEventListener('mousedown', (e: any) => {
            isDown = true;
            slider.classList.add('active');
            startX = e.pageX;
            scrollLeft = slider.scrollLeft;
        });
        slider.addEventListener('mouseleave', () => {
            isDown = false;
            slider.classList.remove('active');
        });
        slider.addEventListener('mouseup', () => {
            isDown = false;
            slider.classList.remove('active');
        });
        slider.addEventListener('mousemove', (e: any) => {
            if (!isDown) {
                return;
            }
            e.preventDefault();
            const x = e.pageX;
            const walk = x - startX;
            slider.scrollLeft = scrollLeft - walk;
        });
    }

    goLevel(data: any) {
        this.gameActive = this.mapService.getActiveGame();
        const currentAccount: Account = this.mapService.getCurrentAccount();
        if (this.gameActive === 'lock' && data.level > MAX_LEVEL_UNLOCK) {
            if (this.platform.is('ios')) {
                this.noticationService.create(this.translate.instant('auth.upgradePremium'));
                return;
            }
            if (currentAccount && currentAccount.id) {
                $('.ma-kh').fadeIn(200);
                $('.popup-box').removeClass('transform-out').addClass('transform-in');
                return;
            } else {
                this.noticationService.create(this.translate.instant('auth.upgradePremium'));
                return;
            }
        }
        if (data.level > data.currentLevel) {
            return;
        }
        this.gameInit = true;
        if (data.level > 15 && data.page === 'sweet-basic') {
            data.page = 'sweet-basic-2';
        }
        if (data.level > 15 && data.page === 'env-basic') {
            data.page = 'env-basic-2';
        }
        if (data.level > 10 && data.page === 'sweet-condition') {
            data.page = 'sweet-condition-2';
        }
        if (data.level > 10 && data.page === 'env-condition') {
            data.page = 'env-condition-2';
        }
        this.router.navigate([data.page], {queryParams: data});
        // this.playSounds(MUSIC.selectLevel).then(() => {
        //     this.router.navigate([data.page], { queryParams: data });
        // }).catch();

    }

    //
    // playSounds(file: string) {
    //     return new Promise((resolve, reject) => {
    //         if (soundMute === true) {
    //             playSound(file).then(() => {
    //                 resolve('ok');
    //             }).catch(e => {
    //                 reject();
    //             });
    //         } else {
    //             resolve('ok');
    //         }
    //     });
    // }
}
